/**
* Gets the height of the footer element.
*/
const footer = document.querySelector('footer.wp-block-template-part');

if (footer) {
	const setFooterHeight = () => {
		const footerHeight = footer.offsetHeight;
		document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
	};
	
	setFooterHeight();
	
	window.addEventListener('resize', setFooterHeight);
}

// Select the email input field
var emailInput = document.getElementById('mce-EMAIL');

if (emailInput) {
	// Add event listener for focus event
	emailInput.addEventListener('focus', function() {
		// Change the placeholder text when the input field is focused
		this.placeholder = 'Email address here';
	});

	// Add event listener for blur event
	emailInput.addEventListener('blur', function() {
		// Change the placeholder text back when the input field loses focus
		this.placeholder = 'LJ Quarterly email sign-up';
	});
}

// Select the form and the response element
var form = document.getElementById('mc-embedded-subscribe-form');
var responseElement = document.getElementById('mce-success-response');

if (form) {
	// Create a MutationObserver instance to listen for changes in the response element
	var observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutation) {
			// Check if the text is 'Thank you for subscribing!'
			if (mutation.target.textContent.trim() === 'Thank you for subscribing!') {
				// Add the 'success' class to the form
				form.classList.add('success');
			}
		});
	});

	// Start observing the response element with the configured parameters
	observer.observe(responseElement, { childList: true, characterData: true, subtree: true });
}

// Make the work block minimum height the same as the image height.
function getActualHeight(imgElement) {
	const clone = imgElement.cloneNode();
	
	const styles = {
		position: 'absolute',
		visibility: 'hidden',
		left: '-9999px',
		display: 'block'
	};
	
	for (let style in styles) {
		clone.style[style] = styles[style];
	}
	
	document.body.appendChild(clone);
	const height = clone.clientHeight;
	document.body.removeChild(clone);
	
	return height;
}

window.addEventListener('load', () => {
	const images = document.querySelectorAll('.display-work__image img');
	let tallestImageHeight = 0;
	
	images.forEach(img => {
		const imgHeight = getActualHeight(img);
		tallestImageHeight = Math.max(tallestImageHeight, imgHeight);
	});
	
	if (tallestImageHeight > 0) {
		const listView = document.querySelector('.display-work_list-view');
		if (listView) {
			listView.style.minHeight = `${tallestImageHeight}px`;
		}
	}
});

// Toggle View
const listViewButton = document.querySelector('.list-view');
const imageViewButton = document.querySelector('.image-view');
const displayWorkList = document.querySelector('.display-work');

if (listViewButton && imageViewButton && displayWorkList) {
	function setViewMode(listView) {
		const toggleClass = (element, className, condition) => {
			element.classList.toggle(className, condition);
			element.setAttribute('aria-pressed', condition);
		};
		
		toggleClass(listViewButton, 'active', listView);
		toggleClass(imageViewButton, 'active', !listView);
		displayWorkList.classList.toggle('display-work_list-view', listView);
		displayWorkList.classList.toggle('display-work_image-view', !listView);
		displayWorkList.focus();
	}
	
	listViewButton.addEventListener('click', () => setViewMode(true));
	imageViewButton.addEventListener('click', () => setViewMode(false));
	
	function handleViewModeKeyPress(event, listView) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			setViewMode(listView);
		}
	}
	
	listViewButton.addEventListener('keydown', (event) => handleViewModeKeyPress(event, true));
	imageViewButton.addEventListener('keydown', (event) => handleViewModeKeyPress(event, false));
}

// Filter the list of work
const filterButtons = document.querySelectorAll('.filter button');
const listItems = document.querySelectorAll('.display-work__item');

function applyFilter(filter) {
	listItems.forEach(item => {
		if (filter === 'all' || item.classList.contains(filter)) {
			item.classList.remove('hidden');
			item.removeAttribute('aria-hidden');
		} else {
			item.classList.add('hidden');
			item.setAttribute('aria-hidden', 'true');
		}
	});
}

if (filterButtons.length > 0 && listItems.length > 0) {
	filterButtons.forEach(button => {
		button.addEventListener('click', () => {
			// Remove active class from dropdown
			document.querySelector('.dropdown-filter').classList.remove('active');
			// Change the text of the dropdown label to the clicked button text
			document.querySelector('.dropdown-filter__label').textContent = button.textContent;
			// Remove active class from all buttons
			filterButtons.forEach(btn => btn.classList.remove('active'));
			// Add active class to clicked button
			button.classList.add('active');
			// Filter list items
			const filter = button.getAttribute('data-filter');
			applyFilter(filter);
		});
	});
	
	// Check for URL query parameters
	const params = new URLSearchParams(window.location.search);
	const serviceValue = params.get('service');
	
	if (serviceValue) {
		// Find the button that has the data-filter matching the serviceValue
		const matchingButton = Array.from(filterButtons).find(button => button.getAttribute('data-filter') === serviceValue);
		if (matchingButton) {
			matchingButton.click();
		}
	}
}

// Select the dropdown-filter__label element
const label = document.querySelector('.dropdown-filter__label');

if (label) {
	// Add click event listener to the label
	label.addEventListener('click', () => {
		// Select the dropdown-filter element
		const filter = document.querySelector('.dropdown-filter');
		
		if (filter) {
			// Toggle the 'active' class
			filter.classList.toggle('active');
		}
	});
}

// Display the image on hover
document.querySelectorAll('.display-work__link').forEach(link => {
	link.addEventListener('mouseover', displayImage);
	link.addEventListener('focus', displayImage);
	link.addEventListener('mouseout', removeImage);
	link.addEventListener('blur', removeImage);
});

// This function is used to display an image when an item is hovered over
function displayImage(event) {
	// Get the closest parent element with the class 'display-work__item'
	const hoveredItem = event.target.closest('.display-work__item');
	
	// Check if the hovered item exists
	if (hoveredItem) {
		// Find the image element within the hovered item
		const imageEl = hoveredItem.querySelector('.display-work__image img');
		
		// Check if the image element exists
		if (imageEl) {
			// Clone the image element
			const clonedImage = imageEl.cloneNode(true);
			// Find the display element where the cloned image will be displayed
			const displayEl = document.querySelector('.display-work__image-display');
			// Calculate the position where the cloned image will be displayed
			const position = Math.min(hoveredItem.offsetTop, displayEl.offsetHeight - clonedImage.height - 8);
			
			// Set the margin-top style of the cloned image to the calculated position
			clonedImage.style.marginTop = `${position}px`;
			
			// Clear the inner HTML of the display element
			displayEl.innerHTML = '';
			// Append the cloned image to the display element
			displayEl.appendChild(clonedImage);
		}
	}
}

function removeImage() {
	const displayEl = document.querySelector('.display-work__image-display');
	displayEl.innerHTML = '';
}

document.addEventListener('DOMContentLoaded', () => {
	const teamMembers = document.querySelectorAll('.team-member');
	
	teamMembers.forEach(member => {
	  const imageStack = member.querySelector('.image-stack');
	  const images = imageStack.querySelectorAll('li');
	  let currentImage = 0;
	  let hoverInterval;
	  
	  const nextImage = () => {
		images[currentImage].style.zIndex = 1;
		currentImage = (currentImage + 1) % images.length;
		images[currentImage].style.zIndex = 100;
	  };
	  
	  const startHoverEffect = () => {
		if (!hoverInterval) { // Only set the interval if it's not already set
		  hoverInterval = setInterval(nextImage, 250);
		}
	  };
  
	  const stopHoverEffect = () => {
		clearInterval(hoverInterval);
		hoverInterval = null; // Clear the interval ID
		images.forEach(img => (img.style.zIndex = 1));
		currentImage = 0;
		images[currentImage].style.zIndex = 100;
	  };
	  
	  member.addEventListener('mouseover', startHoverEffect);
	  member.addEventListener('mouseout', stopHoverEffect);
	});
  });
  

// Masthead Slider
jQuery( document ).ready( function( $ ) {
	
	$(document).ready(function() {
		$('.slider').slick({
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  autoplay: true,
		  autoplaySpeed: 6000,
		  infinite: true,
		  prevArrow: '<button class="slick-prev">Previous</button>',
		  nextArrow: '<button class="slick-next">Next</button>',
		  arrows: true,
		  pauseOnHover: false,
		 // lazyLoad: 'progressive',
		});

		var activeVideo = $('.slick-active').find('video');
		var allVideos = $('.slider-item').find('video');

		// Pause all videos
		allVideos.each(function(index, video) {
			video.pause();
		});

		if (activeVideo.length > 0) {
			activeVideo.get(0).play();
		}

		$('.slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
			var activeVideo = $('.slick-active').find('video');
			var allVideos = $('.slider-item').find('video');

			// Pause all videos
			allVideos.each(function(index, video) {
				video.pause();
			});

			if (activeVideo.length > 0) {
				activeVideo.get(0).play();
			}

		});

		// Check if .masthead-slider-block element is present
		if (document.querySelector('.masthead-slider-block')) {

			// Circle Cursor
			var cursor = document.getElementById("cursor");
			document.body.addEventListener("mousemove", function(e) {
			cursor.style.left = e.clientX + "px",
				cursor.style.top = e.clientY + "px";
			});


			// Display Next or Previous on hover
			document.querySelector('.slick-prev').addEventListener('mouseover', function() {
				document.getElementById('cursor').setAttribute('data-hover-text', 'Previous');
			});

			document.querySelector('.slick-next').addEventListener('mouseover', function() {
				document.getElementById('cursor').setAttribute('data-hover-text', 'Next');
			});

			document.querySelector('.slick-prev').addEventListener('mouseout', function() {
				document.getElementById('cursor').setAttribute('data-hover-text', '');
			});

			document.querySelector('.slick-next').addEventListener('mouseout', function() {
				document.getElementById('cursor').setAttribute('data-hover-text', '');
			});

			// Max Width
			function setMaxWidth() {
				let viewportWidth = window.innerWidth + "px";
				let slideContents = document.querySelectorAll('.slide-content');

				slideContents.forEach(element => {
					element.style.maxWidth = viewportWidth;
				});
			}

			// Initial application
			setMaxWidth();

			// Apply max-width on window resize
			window.addEventListener('resize', setMaxWidth);

		}

	  });
	
} );

// Logo Grid
const logoGrid = document.querySelector('.logo-grid');

if (logoGrid) {
	function markLastRowElements() {
		// Get all the elements
		let logos = document.querySelectorAll('.logo-grid__logo');
		let totalLogos = logos.length;
	
		// Determine number of columns based on viewport width
		let columns;
		let width = window.innerWidth;
	
		if (width >= 1080) {
			columns = 6;
		} else if (width >= 375) {
			columns = 3;
		} else {
			columns = 2;
		}
	
		// Calculate number of logos in the last row
		let logosInLastRow = totalLogos % columns;
		if (logosInLastRow === 0) { // If it's perfectly divisible, then it means the last row is full
			logosInLastRow = columns;
		}
	
		// Clear the previous last-row classes
		logos.forEach(logo => logo.classList.remove('last-row'));
	
		// Apply the 'last-row' class to logos in the last row
		for (let i = totalLogos - logosInLastRow; i < totalLogos; i++) {
			logos[i].classList.add('last-row');
		}
	}
	
	// Initial call
	markLastRowElements();
	
	// Add event listener to handle window resizing
	window.addEventListener('resize', markLastRowElements);
	
}

// Check if .stuff-block element is on the page
if (document.querySelector('.stuff-block')) {
	// Select the #header element
	var header = document.querySelector('#header');

	// Apply the CSS
	header.style.position = 'fixed';
	header.style.left = '0';
	header.style.right = '0';
	header.style.zIndex = '9999';


	// Select all the children of .stuff-block__innerblocks
	var elements = document.querySelectorAll('.stuff-block__innerblocks > *');

	// Convert NodeList to Array
	var elementsArray = Array.prototype.slice.call(elements);

	// Apply z-index from highest to lowest
	elementsArray.forEach((element, index) => {
		element.style.zIndex = elementsArray.length - index;
	});

}
